"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.S = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var ternary_lint_util_1 = require("../../utils/ternary-utils/ternary-lint-util");
var IconWithHyperlink = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n"], ["\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n"])));
var buttonStyledSecondary;
var Button = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  align-items: center;\n  border: none;\n  background: none;\n  cursor: pointer;\n\n  &:hover {\n    .icon {\n      stroke: ", ";\n    }\n\n    .label {\n      color: ", ";\n    }\n  }\n"], ["\n  ", "\n  display: flex;\n  align-items: center;\n  border: none;\n  background: none;\n  cursor: pointer;\n\n  &:hover {\n    .icon {\n      stroke: ", ";\n    }\n\n    .label {\n      color: ", ";\n    }\n  }\n"])), function (props) {
    buttonStyledSecondary = (0, ternary_lint_util_1.retornaValorCondicionado)(props.secundary, props.theme.p003, props.theme.action003);
    return '';
}, function (props) { return (props.disabled ? props.theme.p003 : buttonStyledSecondary); }, function (props) { return (props.disabled ? props.theme.p003 : buttonStyledSecondary); });
var Text = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 8px;\n"], ["\n  margin-left: 8px;\n"])));
exports.S = {
    Text: Text,
    Button: Button,
    IconWithHyperlink: IconWithHyperlink,
};
var templateObject_1, templateObject_2, templateObject_3;
